import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Select } from 'semantic-ui-react';
import InputNumberFormat from 'components/common/InputNumberFormat';
import { toDropDownOptions } from 'utils/dropdownOptions';
import MyDropzone from 'components/common/DragAndDrop';

const TopupNGOForm = ({
  onChange,
  setFile,
  file,
  wallets,
  setWalletId,
}) => {
  const handleDeleteAttach = () => {
    setFile({});
  };

  const handleChangeAttach = e => {
    e.preventDefault();
    setFile(e.target?.files[0]);
  };

  const handleChange = (e, { name, value }) => {
    if (name === 'channel') {
      const selectedWalletId = wallets?.items?.find(wallet => {
        return wallet?.provider_name
          .toLowerCase()
          .includes(value.split(' ')?.[0]?.toLowerCase());
      })?.id;

      setWalletId(selectedWalletId);
    }
    onChange(name, value);
  };
  return (
    <div>
      <Form.Field
        required
        name="channel"
        control={Select}
        fluid
        options={toDropDownOptions(
          ['MTN_Rwanda', 'AIRTEL_Rwanda'],
          true,
        )}
        label="Wallet"
        placeholder="Select"
        onChange={handleChange}
      />

      <InputNumberFormat
        required
        name="amount"
        control={Input}
        label="Amount"
        type="number"
        placeholder="Amount..."
        onChange={handleChange}
      />

      <MyDropzone
        label="Attachment"
        setFile={setFile}
        file={file}
        accept="image/png, image/jpeg, .pdf"
        variant="pdf"
        showPreview={false}
        handleDeleteAttach={handleDeleteAttach}
        handleChangeAttach={handleChangeAttach}
      />

      <Form.TextArea
        required
        label="Description"
        placeholder="Description"
        name="description"
        className="textarea"
        onChange={handleChange}
      />
    </div>
  );
};

TopupNGOForm.defaultProps = {
  file: {},
};

TopupNGOForm.propTypes = {
  wallets: PropTypes.instanceOf(Object).isRequired,
  setWalletId: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  setFile: PropTypes.func.isRequired,
  file: PropTypes.instanceOf(Object),
};

export default TopupNGOForm;
